import Icon from "../../components/Icon";
import styles from "./menuLink.module.css";
import { Link } from "react-router-dom";

const MenuLink = ({ caption, to }) => {
  return (
    <div className={styles.menuLinkContainer}>
      <h4 style={{ margin: "0" }}>
        {to != null ? (
          <Link to={to} className={styles.menuLink}>
            {caption}
          </Link>
        ) : (
          caption
        )}
      </h4>
      <div className={styles.spacer} />
      <Icon chevronDown />
    </div>
  );
};

export default MenuLink;
